<script lang="ts">
	import { Card } from '$lib/components';

	type Props = {
		answers: {
			question: string;
			answer: string;
		}[];
	};

	let { answers }: Props = $props();
</script>

<div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
	{#each answers as { question, answer }}
		<Card>
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			<p class="font-bold mb-2">{@html question}</p>
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			<p>{@html answer}</p>
		</Card>
	{/each}
</div>
